"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_MAP_BOARD_DELETE = exports.API_MAP_BOARD_FETCH_PUBLIC = exports.API_MAP_BOARD_LIST_PUBLIC = exports.API_MAP_BOARD_SAVE = exports.API_MAP_BOARD_FETCH = exports.API_MAP_BOARD_LIST = void 0;
var API_MAP_BOARD_LIST;
(function (API_MAP_BOARD_LIST) {
    API_MAP_BOARD_LIST.PATH = '/map-board/list';
    API_MAP_BOARD_LIST.PURPOSE = '지도연동게시물 목록조회';
})(API_MAP_BOARD_LIST = exports.API_MAP_BOARD_LIST || (exports.API_MAP_BOARD_LIST = {}));
var API_MAP_BOARD_FETCH;
(function (API_MAP_BOARD_FETCH) {
    API_MAP_BOARD_FETCH.PATH = '/map-board/fetch';
    API_MAP_BOARD_FETCH.PURPOSE = '지도연동게시물 조회';
})(API_MAP_BOARD_FETCH = exports.API_MAP_BOARD_FETCH || (exports.API_MAP_BOARD_FETCH = {}));
var API_MAP_BOARD_SAVE;
(function (API_MAP_BOARD_SAVE) {
    API_MAP_BOARD_SAVE.PATH = '/map-board/save';
    API_MAP_BOARD_SAVE.PURPOSE = '지도연동게시물 저장';
})(API_MAP_BOARD_SAVE = exports.API_MAP_BOARD_SAVE || (exports.API_MAP_BOARD_SAVE = {}));
var API_MAP_BOARD_LIST_PUBLIC;
(function (API_MAP_BOARD_LIST_PUBLIC) {
    API_MAP_BOARD_LIST_PUBLIC.PATH = '/map-board/list-public';
    API_MAP_BOARD_LIST_PUBLIC.PURPOSE = '지도연동게시물 목록조회';
})(API_MAP_BOARD_LIST_PUBLIC = exports.API_MAP_BOARD_LIST_PUBLIC || (exports.API_MAP_BOARD_LIST_PUBLIC = {}));
var API_MAP_BOARD_FETCH_PUBLIC;
(function (API_MAP_BOARD_FETCH_PUBLIC) {
    API_MAP_BOARD_FETCH_PUBLIC.PATH = '/map-board/fetch-public';
    API_MAP_BOARD_FETCH_PUBLIC.PURPOSE = '지도연동게시물 조회';
})(API_MAP_BOARD_FETCH_PUBLIC = exports.API_MAP_BOARD_FETCH_PUBLIC || (exports.API_MAP_BOARD_FETCH_PUBLIC = {}));
var API_MAP_BOARD_DELETE;
(function (API_MAP_BOARD_DELETE) {
    API_MAP_BOARD_DELETE.PATH = '/map-board/delete';
    API_MAP_BOARD_DELETE.PURPOSE = '지도연동게시물 삭제';
})(API_MAP_BOARD_DELETE = exports.API_MAP_BOARD_DELETE || (exports.API_MAP_BOARD_DELETE = {}));
//# sourceMappingURL=api-map-board.js.map